var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("预览")]),_vm._l((_vm.items),function(item,index){return _c('custom-widget',{key:index,attrs:{"item":item}})}),_c('van-button',{attrs:{"type":"primary"}},[_vm._v("默认按钮")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }